var _path, _path2, _path3, _path4, _circle, _circle2, _circle3, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiploma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Filled_Expand",
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Filled Expand",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m54 60h-36a4 4 0 0 1 -4-4v-48a4 4 0 0 0 -4-4h40a4 4 0 0 1 4 4z",
    fill: "#eceff0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m58 56a4 4 0 0 1 -4 4h-36a4 4 0 0 0 4-4v-4h36z",
    fill: "#bcc1c4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m10 4a4 4 0 0 1 4 4v4a0 0 0 0 1 0 0h-8a0 0 0 0 1 0 0v-4a4 4 0 0 1 4-4z",
    fill: "#bcc1c4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m20 34.5h-12v12l6-6 6 6z",
    fill: "#db3a3a"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 27,
    fill: "#ffdc32",
    r: 10
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 27,
    fill: "#facd1e",
    r: 5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 12,
    fill: "#db3a3a",
    r: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m55 51v-43a5.0059 5.0059 0 0 0 -5-5h-40a5.0059 5.0059 0 0 0 -5 5v5h8v3.0507a10.9915 10.9915 0 0 0 -6 19.4279v13.4355l6-6v13.0859a5.0059 5.0059 0 0 0 5 5h36a5.0059 5.0059 0 0 0 5-5v-5zm-48-40v-3a3 3 0 0 1 6 0v3zm-2 16a9 9 0 1 1 9 9 9.01 9.01 0 0 1 -9-9zm4 9.7857a10.9011 10.9011 0 0 0 10 0v7.3l-5-5-5 5zm12 19.2143a3 3 0 0 1 -6 0v-13.0859l6 6v-13.4355a10.9915 10.9915 0 0 0 -6-19.4279v-8.0507a4.9732 4.9732 0 0 0 -1.002-3h36.002a3.0033 3.0033 0 0 1 3 3v43h-32zm36 0a3.0033 3.0033 0 0 1 -3 3h-32.002a4.9732 4.9732 0 0 0 1.002-3v-3h34z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m20 9h14v2h-14z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m29 18h7v2h-7z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m29 24h14v2h-14z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m29 30h14v2h-14z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "m29 36h14v2h-14z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "m35 45h14v2h-14z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m46 8a4 4 0 1 0 4 4 4.0039 4.0039 0 0 0 -4-4zm0 6a2 2 0 1 1 2-2 2.0027 2.0027 0 0 1 -2 2z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m14 33a6 6 0 1 0 -6-6 6.0066 6.0066 0 0 0 6 6zm0-10a4 4 0 1 1 -4 4 4.0039 4.0039 0 0 1 4-4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiploma);
export default __webpack_public_path__ + "static/media/diploma.bd5d9c019acca23ca1557ed233dccfef.svg";
export { ForwardRef as ReactComponent };